// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__3W_Sd","Button":"Header_Button__2XABB","HistoryHeader":"Header_HistoryHeader__3_f6w","Text":"Header_Text__2aVAg","Hidden":"Header_Hidden__15jhU"};